import { SendDocumentPayload } from '@interfaces/document'
import api from '../api'
import { VersionPartiesObject } from '@interfaces/ai'

const getAll = () => {
  return api.get('/api/docs')
}

const getByPublicId = (publicId: string) => {
  return api.get(`/api/docs/${publicId}`)
}

const getStatusByPublicId = (publicId: string) => {
  return api.get(`/api/docs/status/${publicId}`)
}

const getContentsByPublicId = (publicId: string) => {
  return api.get(`/api/docs/contents/${publicId}`)
}

const setInitialEditorState = (publicId: string, payload: { editorState: any }) => {
  return api.post(`/api/docs/set-initial-editor-state/${publicId}`, payload)
}

const saveNewVersion = (publicId: string, data: any) => {
  return api.post(`/api/docs/save-new-version/${publicId}`, {
    data,
  })
}

const updateEditorState = (publicId: string, data: any) => {
  return api.post(`/api/docs/update-editor-state/${publicId}`, {
    data,
  })
}

const update = (publicId: string, data: { file_name?: string; metadata?: Record<string, unknown> }) => {
  return api.patch(`/api/docs/${publicId}`, data)
}

const updateVersionDetails = (publicId: string, dto: { parties?: Partial<VersionPartiesObject> }) => {
  return api.patch(`/api/docs/version/${publicId}`, dto)
}

const deleteByPublicId = (publicId: string) => {
  return api.delete(`/api/docs/${publicId}`)
}

const upload = (data: FormData) => {
  return api.post('/api/docs/upload-and-process', data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

const send = async (payload: SendDocumentPayload) => {
  return api.post(`/api/docs/send`, payload).then(res => res.data)
}

const getByShareLinkId = (shareLinkId: string) => {
  return api.get(`/api/docs/shared/${shareLinkId}`)
}

const getDocumentsMetricsByType = (type: 'basic' | 'stats' | 'issues' | 'reviews' | 'sends') => {
  return api.get(`/api/docs/metrics?type=${type}`).then(res => res.data)
}

const checkExportEligibility = (publicId: string) => {
  return api.get(`/api/docs/check-export-eligibility/${publicId}`)
}

export const docs = {
  getAll,
  getByPublicId,
  getStatusByPublicId,
  getContentsByPublicId,
  setInitialEditorState,
  updateEditorState,
  update,
  updateVersionDetails,
  saveNewVersion,
  deleteByPublicId,
  upload,
  send,
  getByShareLinkId,
  getDocumentsMetricsByType,
  checkExportEligibility,
}
